import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Rarity } from '__generated__/globalTypes';
import { Horizontal } from 'atoms/layout/flex';
import { BrandS } from 'atoms/typography';
import { scarcityMessages } from 'lib/scarcity';
import { toCamelCase } from 'lib/toCamelCase';

const Root = styled(Horizontal)`
  border-radius: var(--half-unit);
  padding: var(--half-unit) var(--unit);
`;

type Props = { scarcity: Rarity };
export const ScarcityTag = ({ scarcity }: Props) => {
  if (!scarcityMessages[scarcity]) {
    return null;
  }

  return (
    <Root
      className={classNames({ [scarcity]: true })}
      style={{
        background: `var(--c-gradient-${toCamelCase(scarcity)})`,
        color: [Rarity.limited, Rarity.common].includesValue(scarcity)
          ? 'var(--c-black)'
          : 'var(--c-white)',
      }}
    >
      <BrandS bold>
        <FormattedMessage {...scarcityMessages[scarcity]} />
      </BrandS>
    </Root>
  );
};
